<template>
  <div
    v-if="show"
    :class="[
      bemBlock,
    ]"
    :style="cssCustomProps"
  >
    <p
      :class="[
        bemElement('title'),
      ]"
    >
      {{ filterDisplayName }}
    </p>
    <div
      :class="[
        bemElement('content')
      ]"
    >
      <slot
        :options="options"
      >
        <button
          v-for="(option, index) in options"
          :key="index"
          :class="[
            bemElement('option', {
              selected: isOptionSelected(option),
              'col-break': option.isFirstNumber,
            }),
            'btn',
            'btn--secondary',
            'interaction--enabled-hover-v1'
          ]"
          :disabled="disabled"
          @click="handleOptionClick($event, option)"
        >
          <slot
            name="optionContent"
            :option="option"
          >
            {{ option.displayValue }}
          </slot>
        </button>
      </slot>
      <slot
        name="content"
      />
    </div>
  </div>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';

export default {
  name: 'BaseFilters',

  mixins: [
    bemClassesMixin,
  ],

  props: {
    cssCustomProps: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filterDisplayName: {
      type: String,
      default: '',
    },
    isSelectMultiple: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    selected: {
      type: [Array, Object],
      default: () => ([]),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    selectedOptions: null,
  }),

  watch: {
    selected() {
      this.selectedOptions = this.selected;
    },
  },

  mounted() {
    this.selectedOptions = this.selected;
  },

  methods: {
    isOptionSelected(option) {
      return this.isSelectMultiple
        ? !!this.selectedOptions?.find((selectedOption) => selectedOption.value === option.value)
        : this.selectedOptions?.id === option.id;
    },
    handleOptionClick(event, option) {
      if (this.isSelectMultiple) {
        this.handleMultipleSelection(option);
      } else {
        this.handleSingleSelection(option);
      }
    },
    handleMultipleSelection(option) {
      if (this.isOptionSelected(option)) {
        this.selectedOptions = this.selectedOptions?.filter(
          (selectedOption) => (selectedOption.value !== option.value),
        );
        this.$emit('deselect', option);
      } else {
        this.selectedOptions?.push(option);
        this.$emit('select', option);
      }
    },
    handleSingleSelection(option) {
      const selectedOption = this.isOptionSelected(option) ? null : option;
      this.selectedOptions = selectedOption;
      this.$emit('select', selectedOption);
    },
  },
};
</script>
